import * as Sentry from "@sentry/react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { fetchBlocks } from "@/api/quiz";
import { CustomFormBlock } from "@/types";

const useLoadQuizBlocks = (fetchPath?: string | null) => {
  const [loading, setLoading] = useState(true);
  const [quizBlocks, setQuizBlocks] = useState<CustomFormBlock[] | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const loadBlocks = async () => {
    try {
      if (!fetchPath) {
        return;
      }

      setErrorMessage(null);
      const fetchedBlocks: CustomFormBlock[] = await fetchBlocks(fetchPath);

      setQuizBlocks(fetchedBlocks);
    } catch (error) {
      Sentry.captureException(error);
      const message =
        error instanceof Error ? error.message : "An error occurred";
      setErrorMessage(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (fetchPath) {
      loadBlocks();
    }
  }, [fetchPath]);

  return { loading, quizBlocks, errorMessage };
};

export { useLoadQuizBlocks };
